import React from 'react';
import { Link } from 'react-router-dom';
import { RoutePaths } from '../../Common/ClientRoutes';

export const SingleUser = props => {
    return (
        <tr>
            <td>{props.names}</td>
            <td />
            <td>{props.role}</td>
            <td />
            <td>{props.company}</td>
            <td />
            <td>{props.pharmacy}</td>
            <td />
            <td>{props.email}</td>
            <td />
            <td>{props.phone}</td>
            <td className="qf-hidden-box">
                <Link to={RoutePaths.EDIT_USER(props.id)}>
                    <i className="fa fa-pencil-square-o" />
                </Link>
            </td>
        </tr>
    );
};




// WEBPACK FOOTER //
// ./src/customModules/Users/components/Single-user.js